import { render, staticRenderFns } from "./c-tag.vue?vue&type=template&id=2e762b26&scoped=true&"
import script from "./c-tag.vue?vue&type=script&lang=js&"
export * from "./c-tag.vue?vue&type=script&lang=js&"
import style0 from "./c-tag.vue?vue&type=style&index=0&id=2e762b26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e762b26",
  null
  
)

export default component.exports